import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  pendingSignatures: "Pending Signatures",
  signedTotal: (n: string) => `${n} signed total`,
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    pendingSignatures: "Signatures en attente",
    signedTotal: (n) => `${n} signées au total`,
  },
  es_ES: {
    pendingSignatures: "Firmas pendientes",
    signedTotal: (n) => `${n} firmadas en total`,
  },
  pt_BR: {
    pendingSignatures: "Assinaturas pendentes",
    signedTotal: (n) => `${n} assinadas no total`,
  },
  de_DE: {
    pendingSignatures: "Ausstehende Signaturen",
    signedTotal: (n) => `${n} insgesamt signiert`,
  },
  it_IT: {
    pendingSignatures: "Firme in attesa",
    signedTotal: (n) => `${n} firmate in totale`,
  },
  ar: {
    pendingSignatures: "التوقيعات المعلّقة",
    signedTotal: (n) => `${n} موقّعة إجمالًا`,
  },
  ja_JP: {
    pendingSignatures: "署名待ち",
    signedTotal: (n) => `署名済み 計 ${n} 件`,
  },
  hi_IN: {
    pendingSignatures: "लंबित हस्ताक्षर",
    signedTotal: (n) => `कुल ${n} हस्ताक्षरित`,
  },
  zh_CN: {
    pendingSignatures: "待签署",
    signedTotal: (n) => `累计已签署 ${n} 份`,
  },
  zh_TW: {
    pendingSignatures: "待簽署",
    signedTotal: (n) => `累計已簽署 ${n} 份`,
  },
  nl_NL: {
    pendingSignatures: "Openstaande ondertekeningen",
    signedTotal: (n) => `${n} ondertekend in totaal`,
  },
  nb_NO: {
    pendingSignatures: "Ventende signaturer",
    signedTotal: (n) => `${n} signert totalt`,
  },
  sv_SE: {
    pendingSignatures: "Väntande signaturer",
    signedTotal: (n) => `${n} signerade totalt`,
  },
  fi_FI: {
    pendingSignatures: "Odottavat allekirjoitukset",
    signedTotal: (n) => `${n} allekirjoitettu yhteensä`,
  },
  da_DK: {
    pendingSignatures: "Afventende signaturer",
    signedTotal: (n) => `${n} underskrevet i alt`,
  },
  is_IS: {
    pendingSignatures: "Undirritanir í bið",
    signedTotal: (n) => `${n} undirritað alls`,
  },
};
